module.exports = __webpack_public_path__ + "img/RS.aa9e47d9.svg";